import { render, staticRenderFns } from "./NewBatchNumberModal.vue?vue&type=template&id=322ab2ba&"
import script from "./NewBatchNumberModal.vue?vue&type=script&lang=js&"
export * from "./NewBatchNumberModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports